import React from "react";
import { Col, Row, Modal, Form, Input, Select, Button, Tooltip } from "antd";
import { ProfileFilled, SaveFilled } from "@ant-design/icons";
import "./ControlsModal.css";
const { Option } = Select;

const ControlsModal = ({ 
  areas, 
  categories,
  priorities,
  frameworks,
  types,
  risks,
  isModalOpen, 
  setIsModalOpen, 
  form, 
  handleSave, 
  editingControl,
  inputRef
}) => {

  return (
    <Modal
      className="controls-modal"
      title={
        <span>
          <ProfileFilled style={{ marginRight: 8 }} />
          {editingControl ? "Editar Control" : "Agregar Control"}
        </span>
      }
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      onOk={() => form.submit()}
      cancelButtonProps={{ className: "cancel-button" }}
      okButtonProps={{ className: "save-type-button" }}
      cancelText="Cancelar"
      width={700}
      okText={
        <span>
          <SaveFilled style={{ marginRight: 6 }} />
          Guardar
        </span>
      }
      bodyStyle={{ overflowY: "auto" }}
      footer={[
        <Button
          key="cancel"
          className="cancel-button"
          onClick={() => setIsModalOpen(false)}
        >
          Cancelar
        </Button>,
        <Button
          key="save"
          className="save-type-button"
          onClick={() => form.submit()}
          icon={<SaveFilled />}
        >
          Guardar
        </Button>
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item name="title" label="Nombre" rules={[{ required: true, message: "Nombre requerido" }]}>
          <Input.TextArea
            ref={inputRef}
            maxLength={150} 
            showCount 
            style={{ resize: 'none', width: '100%', height: '80px' }} 
          />
        </Form.Item>
        <Form.Item name="description" label="Descripción" rules={[{ required: true, message: "Descripción requerida" }]}>
          <Input.TextArea 
            maxLength={1000} 
            showCount 
            style={{ resize: 'none', width: '100%', height: '120px' }} 
          />
        </Form.Item>
        {/* /Campos/ */}
        <Row>
          <Col span={12}>
            <Form.Item 
              name="category" 
              label="Categoría" 
              rules={[{ required: true, message: "Categoría requerida" }]}
            >
              <Select
                showSearch
                placeholder="Seleccione una Categoría"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const extractText = (node) => {
                    if (typeof node === 'string') return node;
                    if (typeof node === 'number') return node.toString();
                    if (Array.isArray(node)) return node.map(extractText).join(' ');
                    if (node?.props?.children) return extractText(node.props.children);
                    return '';
                  };

                  const text = extractText(option?.children);
                  return text.toLowerCase().includes(input.toLowerCase());
                }}
                notFoundContent="No se encontraron resultados"
              >
                {categories.map(category => {
                  const name = category.name || "-";
                  const displayName =
                    name.length > 35 ? `${name.substring(0, 35)}...` : name;

                  return (
                    <Option key={category.id} value={category.id}>
                      {name.length > 35 ? (
                        <Tooltip title={name}>
                          <span>{displayName}</span>
                        </Tooltip>
                      ) : (
                        name
                      )}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item name="type" label="Tipo" rules={[{ required: true, message: "Tipo requerido" }]}>
              <Select placeholder="Seleccione un Tipo">
                {types.map(type => (
                  <Option key={type.id} value={type.id}>
                    {type.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        
        <Row>
          <Col span={8}>
            <Form.Item name="risk" label="Riesgo" rules={[{ required: true, message: "Riesgo requerido" }]}>
              <Select placeholder="Selecciona un Riesgo">
                {risks.map(risk => (
                  <Option key={risk.id} value={risk.id}>
                    {risk.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="priority" label="Prioridad" rules={[{ required: true, message: "Prioridad requerida" }]}>
              <Select placeholder="Selecciona una Prioridad">
                {priorities.map(priority => (
                  <Option key={priority.id} value={priority.id}>
                    {priority.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              name="framework" 
              label="Framework" 
              rules={[{ required: true, message: "Framework requerido" }]}
            >
              <Select placeholder="Seleccione un Framework">
                {frameworks.map(framework => {
                  const name = framework.name || "-";
                  const displayName =
                    name.length > 23 ? `${name.substring(0, 23)}...` : name;

                  return (
                    <Option key={framework.id} value={framework.id}>
                      {name.length > 23 ? (
                        <Tooltip title={name}>
                          <span>{displayName}</span>
                        </Tooltip>
                      ) : (
                        name
                      )}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* /Campos/ */}
        <Form.Item
          name="area"
          label="Responsable"
          rules={[{ required: true, message: "Responsable requerido" }]}
        >
          <Select
            showSearch
            placeholder="Seleccione un Área"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            notFoundContent="No se encontraron resultados"
          >
            {areas.map((area) => (
              <Option key={area.id} value={area.id}>
                {area.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ControlsModal;